// Used inside user/user_appointments/_form.html.erb
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["location", "videoChat", "name", "submit"]
  static values = { videoUrl: String }

  connect() {
    // Remove the delete functionality for the first field
    $('.user-appointment-times .slot').first().find('.remove_fields').css('visibility', 'hidden');

    this.updateSubmitDisabled();
  }

  setVideoLocation(event) {
    event.preventDefault()
    if (this.hasVideoUrlValue) {
      this.locationTarget.value = this.videoUrlValue
    }
  }

  // required values: name, start date, start time, end date, end time
  checkAllRequiredValues(selector) {
    const elements = document.querySelectorAll(selector);
    for (let element of elements) {
      if (element.value === "") return true;
    }
    return false;
  }

  checkForPastDateInput() {
    const date_input = document.querySelectorAll('.duet-date__input');
    for (let element of date_input) {
      if (element.classList.contains('past-date-time-checker')) return true;
    }
    return false;
  }

  checkForEmptyInputValues() {
    return this.checkAllRequiredValues('#user_appointment_name') ||
           this.checkAllRequiredValues('.start duet-date-picker') ||
           this.checkAllRequiredValues('.start select:not(.duet-date__select--month):not(.duet-date__select--year)') ||
           this.checkAllRequiredValues('.end duet-date-picker') ||
           this.checkAllRequiredValues('.end select:not(.duet-date__select--month):not(.duet-date__select--year)') ||
           this.checkForPastDateInput();
  }

  updateSubmitDisabled() {
    setTimeout(() => {
      this.submitTarget.disabled = this.checkForEmptyInputValues();
    }, 500);
  }
}